import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { dateTimeSaparator } from '../../../../helper/formatDate';
import {
    getWhatsAppAppUrl,
    getWhatsAppWebUrl,
    getServiceBadgeClass
} from '../EnquiryList/enquiryUtils';
import { CallLogSchoolCell } from './CallLogSchoolCell';
import { CallLogRemarkCell } from './CallLogRemarkCell';
import { CallLogMobileCard } from './CallLogMobileCard';
import { FollowUpHistoryModal } from '../FollowUpHistoryModal';

export const getCallLogsColumns = ({ handleReport }) => [
    {
        Header: 'School Details',
        accessor: 'enquiry.name',
        HeaderClass: 'text-start',
        DataClass: 'text-start align-middle',
        Cell: (cell) => (
            <CallLogSchoolCell row={cell.row.original} handleReport={handleReport} />
        )
    },
    {
        Header: 'Phone / Principal',
        accessor: 'enquiry.phone',
        HeaderClass: 'text-start',
        DataClass: 'align-middle text-start',
        Cell: (cell) => {
            const enq = cell.row.original.enquiry || {};
            return (
                <div>
                    {enq.father_name && (
                        <span className="fw-semibold text-dark fs-12 d-block text-truncate" title={`Principal: ${enq.father_name}`}>
                            <i className="ri-user-star-line text-muted me-1" />
                            {enq.father_name}
                        </span>
                    )}
                    <a
                        href={`tel:${enq.phone}`}
                        className="text-success fw-medium text-decoration-none d-inline-flex align-items-center fs-13 mt-0.5"
                    >
                        <i className="bx bx-phone me-1 text-success fs-14" />
                        {enq.phone || 'N/A'}
                    </a>
                </div>
            );
        }
    },
    {
        Header: 'Call Time & Staff',
        accessor: 'created_at',
        HeaderClass: 'text-start',
        DataClass: 'align-middle text-start',
        Cell: (cell) => {
            const row = cell.row.original;
            const dt = dateTimeSaparator(row.created_at);
            const user = row.callerUser;
            const callerName = user
                ? `${user.first_name || ''} ${user.last_name || ''}`.trim()
                : 'System / Staff';

            return (
                <div>
                    <span className="fw-bold text-dark fs-12 d-block">
                        <i className="ri-time-line text-primary me-1" />
                        {dt.time || 'N/A'}
                    </span>
                    <span className="text-muted fs-11 d-inline-flex align-items-center mt-0.5">
                        <i className="ri-user-line me-1" />
                        {callerName}
                    </span>
                </div>
            );
        }
    },
    {
        Header: 'Conversation & Next Follow-Up',
        accessor: 'remark',
        HeaderClass: 'text-start',
        DataClass: 'align-middle text-start',
        Cell: (cell) => <CallLogRemarkCell row={cell.row.original} />
    },
    {
        Header: 'Service',
        accessor: 'enquiry.course.name',
        HeaderClass: 'text-center',
        DataClass: 'text-center align-middle',
        Cell: (cell) => {
            const serviceName = cell.row.original.enquiry?.course?.name || cell.value;
            const badgeClass = getServiceBadgeClass(serviceName);
            return (
                <span className={`service-pill-badge ${badgeClass}`}>
                    {serviceName || 'N/A'}
                </span>
            );
        }
    },
    {
        Header: 'Action',
        HeaderClass: 'text-center',
        DataClass: 'text-center align-middle',
        Cell: (cell) => {
            const row = cell.row.original;
            const enq = row.enquiry || {};
            const appUrl = getWhatsAppAppUrl(enq.whatsapp, enq.phone, enq.name);
            const webUrl = getWhatsAppWebUrl(enq.whatsapp, enq.phone, enq.name);

            return (
                <div className="d-flex align-items-center justify-content-center gap-1">
                    {/* WhatsApp */}
                    {(appUrl || webUrl) && (
                        <Dropdown align="end" className="d-inline-block">
                            <Dropdown.Toggle
                                variant="soft-success"
                                size="sm"
                                className="py-1 px-2 border-0 arrow-none d-inline-flex align-items-center"
                                title="Chat on WhatsApp"
                            >
                                <i className="ri-whatsapp-line fs-14 text-success" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="shadow border-0 py-1" style={{ minWidth: '175px' }}>
                                <Dropdown.Item href={appUrl} className="fs-12 py-1.5">WhatsApp App</Dropdown.Item>
                                <Dropdown.Item href={webUrl} target="_blank" rel="noopener noreferrer" className="fs-12 py-1.5">WhatsApp Web</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    )}

                    {/* History Modal */}
                    <FollowUpHistoryModal enquiryId={enq.id} schoolName={enq.name}>
                        <button className="btn btn-sm btn-soft-primary py-1 px-2" title="All Call & SMS History">
                            <i className="ri-chat-3-line fs-13" />
                        </button>
                    </FollowUpHistoryModal>
                </div>
            );
        }
    },
    {
        Header: 'List',
        HeaderClass: 'd-none',
        DataClass: 'd-none',
        listClass: 'list-group-item border-0 px-0 bg-transparent',
        list: (row) => <CallLogMobileCard row={row} handleReport={handleReport} />
    }
];

export default getCallLogsColumns;
